import { Route, Routes } from "react-router";

import { ErrorPage } from "./Error/Error";
import { LoginPage } from "./0_Auth/Login/Login";
import { RecuperarContrasenaPage } from "./0_Auth/RecuperarContrasena/RecuperarContrasena";

import { GestionArticulosPage } from "./1_GestionArticulos/GestionArticulos";

import { EmpaquetadoPage } from "./2_Pedidos/Empaquetado/Empaquetado";
import { LanzarCiclosPage } from "./2_Pedidos/LanzarCiclos/LanzarCiclos";

import { CategorizarArticulosPage } from "./3_Produccion/CategorizarArticulos/CategorizarArticulos";
import { GestionKitsPage } from "./3_Produccion/GestionKits/GestionKits";
import { ImputacionesPage } from "./3_Produccion/Imputaciones/Imputaciones";

import { GestionUbicacionesPage } from "./4_Config/GestionUbicaciones/GestionUbicaciones";
import { GestionUsuariosPage } from "./4_Config/GestionUsuarios/GestionUsuarios";
import { SincroAlmacenPage } from "./4_Config/SincroAlmacen/SincroAlmacen";
import { CambiarContrasenaPage } from "./0_Auth/CambiarContrasena/CambiarContrasena";
import { TemplateMenu } from "../templates/TemplateMenu";
import { TemplateLogin } from "../templates/TemplateLogin";
import { GestionFamiliasOcultasPage } from "./4_Config/GestionFamiliasOcultas/GestionFamiliasOcultas";

export function MyRouter() {
	return (
		<Routes>
			<Route element={<TemplateLogin />} >
				<Route index path="/" element={<LoginPage />} />
				<Route path="/login" element={<LoginPage />} />
				<Route path="/recuperarcontrasena" element={<RecuperarContrasenaPage />} />
				<Route path="/cambiarcontrasena" element={<CambiarContrasenaPage />} />

				<Route path="/error" element={<ErrorPage />} />
			</Route>

			<Route element={<TemplateMenu />} >
				<Route path="/order" element={<GestionArticulosPage />} />

				<Route path="/cycles" element={<LanzarCiclosPage />} />
				<Route path="/empaquetado" element={<EmpaquetadoPage />} />
				<Route path="/gestionKits" element={<GestionKitsPage />} />
				<Route path="/imputaciones" element={<ImputacionesPage />} />
				<Route path="/categorizarArticulos" element={<CategorizarArticulosPage />} />

				<Route path="/syncro" element={<SincroAlmacenPage />} />
				<Route path="/users" element={<GestionUsuariosPage />} />
				<Route path="/locationmanager" element={<GestionUbicacionesPage />} />
				<Route path="/familiasOcultas" element={<GestionFamiliasOcultasPage />} />
			</Route>
		</Routes>
	);
}